<template>
  <div class="h-100">
<!--    loader  -->
    <div v-if="requestStatus" class="loading_page" style=" padding: 10px; background: #1e1e1e; opacity: 0.6;">
      <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
    </div>

    <b-alert v-if="error" show variant="warning" style="height: 40px; margin-bottom: 0;">
        <div class="alert-body">
          <feather-icon
              class="mr-25"
              icon="AlertTriangleIcon"
          />
          <span class="ml-25"> {{error}}</span>
        </div>
      </b-alert>

    <b-sidebar right id="events-sidebar"
        :visible="eventsSideBarStatus || settingsSideBarStatus || containersSideBarStatus"
               @hidden="hideSideBar"
        bg-variant="white"
        sidebar-class="sidebar-lg"
        shadow
        :backdrop="false"
        style="opacity: 0.9"
        width="30rem">


<!--      <div class="loading_page" v-if="requestStatus">-->
<!--        <orbit-spinner :animation-duration="1000" :size="25" :color="'#0e96b1'"/>-->
<!--      </div>-->


      <template v-if="settingsSideBarStatus">

        <div dir="rtl" class="m-2 text-right">

            <h4 class="">اعدادات الخريطة</h4>


          <div class="d-flex justify-content-between">
            <p> تتبع المعدة  </p>
            <b-form-checkbox
                v-model="panTo"
                :checked="panTo"
                class="custom-control-primary"
                name="check-button"
                switch
            />
          </div>


          <div class="d-flex justify-content-between">
            <p>  نقاط التحرك</p>
            <b-form-checkbox
                v-model="showMovePoints"
                :checked="showMovePoints"
                class="custom-control-primary"
                name="check-button"
                switch
            />
          </div>

          <div class="d-flex justify-content-between">
            <p>   ({{ stopsCount }}) نقاط التوقف </p>
            <b-form-checkbox
                v-model="showStopPoints"
                :checked="showStopPoints"
                class="custom-control-danger"
                name="check-button"
                switch
            />
          </div>

          <div class="d-flex justify-content-between">
            <p>  مناطق المعدة  </p>
            <b-form-checkbox
                v-model="showGeofences"
                :checked="showGeofences"
                class="custom-control-primary d-flex align-content-end"
                name="check-button"
                switch
            />
          </div>




        </div>

      </template>

      <template v-else-if="eventsSideBarStatus">

        <div class="m-2 text-right">
          <h5>بيانات المعدة</h5>

          <table v-if="deviceInfo" class="table table-sm table-bordered">
            <tr>
              <td>{{deviceInfo.name}}</td>
              <td> اسم المعدة</td>
            </tr>
            <tr>
              <td>{{deviceInfo.plate}}</td>
              <td>رقم اللوحة</td>
            </tr>
            <tr>
              <td>{{ deviceInfo.speed }}</td>
              <td> السرعة الحالية</td>
            </tr>

            <tr>
              <td>{{ deviceInfo.devicetime }}</td>
              <td> أخر تحديث</td>
            </tr>

            <tr>
              <td>{{ deviceInfo.timeago }}</td>
              <td> تحدثت منذ </td>
            </tr>

            <tr>
              <td>{{ deviceInfo.status }}</td>
              <td> حالة المعدة الحالية </td>
            </tr>

            <tr>
              <td>{{ compactorPlannedContainersCount }}</td>
              <td> عدد الحاويات</td>
            </tr>
            <tr>
              <td>{{ compactorLiftedContainersCount }}</td>
              <td> إجمالي الرفع</td>
            </tr>
          </table>
        </div>

        <div class="mt-5 m-2 text-right">
          <h5>احداث المعدة</h5>
        </div>

        <div dir="rtl">

          <!-- timeline -->

          <app-timeline style="padding: 20px">
            <!--           primary -  warning  - info  - danger -->
            <app-timeline-item v-for="event in events" :key="event.id" :variant="event.variant"
                               :style="{ background: event.id === selectedEventId ? '#38548c3d' : ''}"
                               style="padding-left: 10px">

              <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
                <h6>{{event.name}} </h6>
                <small class="timeline-item-time text-nowrap">{{event.ago}}</small>
              </div>
              <div class="d-flex justify-content-between ">
                <small class="">{{ event.time }}</small>
              </div>
              <div class="d-flex justify-content-between ">
                <p @click="fitOnEvent(event)">{{ event.title }}</p>
              </div>

            </app-timeline-item>

          </app-timeline>
          <!--/ timeline -->

        </div>
      </template>

      <template v-else-if="containersSideBarStatus">
        <div class="m-2 text-right">
          <h5> الحاويات</h5>

          <table class="table table-sm table-bordered">
            <tr>
              <th>اخر رفع</th>
              <th>رقم الحاوية</th>
              <th>كود الحاوية</th>
            </tr>
            <tr v-for="container in containersList" :key="container.tag">
              <td>{{container.lastupdate}}</td>
              <td>{{container.code}}</td>
              <td>{{container.tag}}</td>
            </tr>

          </table>
        </div>
      </template>



    </b-sidebar>

<!--    map    -->
    <div dir="ltr" class="h-100">
      <div class="h-100" id="map" ref="mapContainer"></div>
    </div>

  </div>
</template>


<script>
import {
  BAlert,
  BAvatar,
  BAvatarGroup,
  BButton, BCard, BCardBody, BCardHeader, BCardText, BCardTitle,
  BCol,
  BCollapse,
  BForm, BFormCheckbox,
  BFormGroup,
  BFormInvalidFeedback, BImg, BMedia, BMediaAside, BMediaBody,
  BRow, BSidebar
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { onMounted, onUnmounted, reactive, ref, watch } from '@vue/composition-api'
import store from '@/store'
import vSelect from 'vue-select'
import axios from '@/libs/axios'
import { eventBus } from '@/main'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import { timeToString } from '@/utils/time.utils'
import router from '@/router'
import AlertIcon from '@/views/components/alert/AlertIcon.vue'
import Vue from 'vue'
import PointPopup from '@/views/maps/popup/PointPopup.vue'
import ContainerPopup from '@/views/maps/popup/ContainerPopup.vue'
import MarkerPopup from '@/views/maps/popup/MarkerPopup.vue'
import Queue from '@/utils/queue'
import webSocketManager from '@/services/webSocketManager'
import moment from 'moment'
import ToastContent from '@core/components/toastification/ToastificationContent.vue'
import trans from '@/libs/i18n'


export default {

  components: {
    BCardText,
    BFormCheckbox,
    BAlert,
    AlertIcon,
    BCard,
    BCardHeader,
    BCardTitle,
    BSidebar,
    BMedia,
    BCardBody,
    BImg,
    BMediaAside,
    BMediaBody,
    BAvatar,
    BAvatarGroup,
    AppTimeline,
    AppTimelineItem,
    vSelect,
    BFormInvalidFeedback,

    BCollapse,
    BButton,
    BRow,
    BCol,
    flatPickr,
    OrbitSpinner
  },

  setup() {

    const compactorId = router.currentRoute.params.id

    const containersList = ref([])

    const eventsSideBarStatus = ref(false)
    const settingsSideBarStatus = ref(false)
    const containersSideBarStatus = ref(false)

    const requestStatus = ref(true)
    const mapContainer = ref(null);
    const map = ref(null);

    const deviceInfo = ref(null);
    const devices = ref([]);
    const devicePath = ref(null)

    const movingQueue = new Queue()

    const containersCircles = ref([])
    const containersOutPlanCircles = ref([])
    const circles = ref([])
    const route = ref(null)
    const routeLine = ref(null)
    const events = ref([])

    const compactorPlannedContainersCount = ref(0)
    const compactorLiftedContainersCount = ref(0)

    const error = ref(null)

    const panTo = ref(false)
    const showPoints = ref(false)
    const showMovePoints = ref(false)
    const showStopPoints = ref(false)
    const showGeofences = ref(true)
    const showContainers = ref(true)

    const stopsCount = ref(0)

    const deviceMarkerLayers = L.layerGroup()
    const devicePathLayers = L.layerGroup()

    const devicePathMovingPointsLayers = L.layerGroup()
    const devicePathStopsPointsLayers = L.layerGroup()
    const areaLayers = L.layerGroup()

    const selectedEventMarker = ref(null)
    const selectedEventId = ref('')

    const info = Vue.extend(PointPopup)
    const containerInfo = Vue.extend(ContainerPopup)
    const markerInfo = Vue.extend(MarkerPopup)

    const pointStyle = { fill: true, fillOpacity: 0.8, stroke: false}
    const containerCircleOptions = {
      renderer: L.canvas({ padding: 0.5 }),
      fill: true,
      fillOpacity: 0.9,
      stroke: false
    }

    let lastEventId;
    let lastRfidEventId;

    let timeoutId;
    let device_category = 'default';

    const today = new Date();
    const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());


    const getDeviceUpdates = callable => {
      axios.get(`compactor/${compactorId}/getUpdates`)
          .then(response => {
            callable(response)
            timeoutId = setTimeout(() => {
              getDeviceUpdates(callable)
            }, 5000)
      })
    }

    const getCompactorPlan = async () => {
      requestStatus.value = true
      try
      {
        const response = await axios.get(`compactor/${compactorId}/getPlan`);
        compactorPlannedContainersCount.value = response.data.containers.length
        route.value = response.data.route
        for (const i in response.data.containers) {
          const container = response.data.containers[i]
          containersList.value[container.tag] = container
          if (container.latitude && container.longitude) {
            const containerCircle = L.circleMarker([container.latitude, container.longitude], {
              ...containerCircleOptions,
              color: 'red', })
                .bindPopup(initNewContainerPopup(container), {closeButton: false,})
            containersCircles.value[container.tag] = containerCircle
            containerCircle.addTo(map.value)
          }
        }

        // landfills && camps
        if (response.data.areas.length > 0) {
          for (const i in response.data.areas) {
            drawArea(response.data.areas[i])
          }
        }
      }

      catch (err) {
        if (err.response && err.response.status === 400) {
          error.value = err.response.data.message
          console.log(err.response.data.message)
        }
      } finally { await getCompactorHistory()}
    }

    const getCompactorHistory = async () => {
      try
      {
        const response = await axios.get(`compactor/${compactorId}/getHistory`);
        deviceInfo.value = response.data.compactor

        initEvents(response.data.events)
        initDeviceMarker(response.data.compactor)
        initDeviceHistoryRoute(response.data.history)
      }
      catch (err) {
        throw err
      }

      finally {

        requestStatus.value = false
        setTimeout(() => {
          getDeviceUpdates(response => {

            const data = response.data
            console.log(data)

            if (data.device_id in devices.value) {
              _move(data)
            }

            if (data.event_id) {
              if (lastEventId !== data.event_id) {

                lastEventId = data.event_id

                Vue.$toast({
                  component: ToastContent,
                  props: {
                    title: getToastTitle(data.event_type),
                    icon: data.event_type,
                    text: data.geofence_name,
                    time: moment(data.event_devicetime).fromNow()
                  },
                });

                pushNewEvent({
                  id: 'e.' + data.event_id,
                  title: data.geofence_name,
                  time: data.event_devicetime,
                  latitude: data.event_latitude,
                  longitude: data.event_longitude,
                }, getVariant(data.event_type))

              }
            }

            if (data.rfid_event_id) {

              if (lastRfidEventId !== data.rfid_event_id) {

                if (new Date(data.rfid_devicetime) < startOfToday) {
                  return; // ignore old lift
                }

                lastRfidEventId = data.rfid_event_id

                compactorLiftedContainersCount.value++
                const type = data.tag in containersCircles.value
                    ? 'lift'
                    : "unknown"

                const latlng = {
                  latitude: data.rfid_latitude,
                  longitude: data.rfid_longitude,
                }

                makePulseMarkerForSeconds(latlng)
                initContainerCircleFromMessage({
                  ...latlng,
                  tag: data.tag,
                  code: data.code,
                  lastupdate: data.rfid_devicetime,
                  inPlan: type !== "unknown"
                })

                pushNewEvent({
                  ...latlng,
                  title: data.tag,
                  time: data.rfid_devicetime,
                  id: 'r.' + data.rfid_event_id,
                }, getVariant(type))

                updateContainerList({
                  tag: data.tag,
                  lastupdate: data.rfid_devicetime
                })

                Vue.$toast({
                  component: ToastContent,
                  props: {
                    title: getToastTitle('lift'),
                    icon: 'lift',
                    text: data.tag,
                    time: moment(data.rfid_devicetime).fromNow()
                  },
                });

              }
            }
          })
        }, 5000)

      }
    }

    const initContainerCircleFromMessage = message => {
      if (message.inPlan) {
        const containerCircle = containersCircles.value[message.tag]
        if (containerCircle) {
          containerCircle.setLatLng([message.latitude, message.longitude]) // comment this line just for test
          containerCircle.setStyle({color: "#d606f3", ...pointStyle})
          containerCircle.bindPopup(initNewContainerPopup(message), {closeButton: false,})
        }
      }

      else
      {
        const containerCircle = L.circleMarker([message.latitude, message.longitude], {
          ...containerCircleOptions,
          color: '#6f42c1', })
            .bindPopup(initNewContainerPopup(message), {closeButton: false,})
        containersOutPlanCircles.value[message.tag] = containerCircle
        containerCircle.addTo(map.value)
      }
    }

    const initDeviceHistoryRoute = points => {

      const arrayOfCoordinates = points.map(obj => [obj.latitude, obj.longitude]);
      if (arrayOfCoordinates.length > 0) {

        devicePath.value = new L.Polyline(arrayOfCoordinates, {
          smoothFactor: 2, color: 'blue', weight: 2, opacity: 0.5 })

        devicePathLayers.addLayer(devicePath.value)
        devicePathLayers.addTo(map.value)
        map.value.fitBounds(devicePath.value.getBounds())

        const myRenderer = L.canvas({ padding: 0.5 });
        const circleOptions = {
          renderer: myRenderer,
          fill: true,
          fillOpacity: 0.5,
          stroke: false
        }

        points.map(point => {
          switch (point.status) {

            case "moving":
              const movePoint = L.circleMarker([point.latitude, point.longitude], {
                ...circleOptions,
                color: '#3a865a', }).bindPopup(initNewPopup(point), {closeButton: false,})
              devicePathMovingPointsLayers.addLayer(movePoint)
              break
            case "stop":
              const stopPoint = L.circleMarker([point.latitude, point.longitude], {
                ...circleOptions,
                color: '#a91f0d'
              }).bindPopup(initNewPopup(point), {closeButton: false,})
              devicePathStopsPointsLayers.addLayer(stopPoint)
              stopsCount.value++
              break
          }
        })


        // start point
        const startPointImg = require(`@/assets/icons/start.svg`)
        const startPointIcon = getIconWithImg(startPointImg)
        const startPointMarker = createMarkerPoint(
            arrayOfCoordinates[0],
            startPointIcon
        )

        startPointMarker.bindPopup(initNewPopup(points[0]), {closeButton: false,})
        startPointMarker.addTo(map.value)
        startPointMarker.setZIndexOffset(99)
      }
    }

    const initEvents = e => {

      for (const i in e) {

        let variant = getVariant(e[i].type)
        let inPlan = true

        const message = { tag: e[i].title, latitude: e[i].position?.latitude,
          longitude: e[i].position?.longitude, code: "", lastupdate: e[i].time }

        console.log('exist',e[i].title in containersCircles.value)

       if (e[i].type === 'lift' && e[i].position.latitude) {
         if (!(e[i].title in containersCircles.value)) {
           console.log('yes not exist')
           variant = getVariant("unknown")
           inPlan = false
         }

         lastRfidEventId = e[i].id
         initContainerCircleFromMessage({...message, inPlan })
       }
       else {
         lastEventId = e[i].id
       }

       pushNewEvent({...message, ...e[i],
         latitude: e[i].position?.latitude,
         longitude: e[i].position?.longitude
       }, variant)

      }
    }

    const pushNewEvent = (e, variant) => {

      events.value.push({
        id: e.id,
        name: variant[1],
        title: e.title,
        time: e.time,
        ago: timeToString(e.time),
        variant: variant[0],
        latitude: e.latitude,
        longitude: e.longitude,
      })
    }

    const updateContainerList = e => {
      if (e.tag in containersList.value) {
        containersList.value[e.tag].lastupdate = e.lastupdate
      }
    }

    const initDeviceMarker = device => {

      if (!device.latitude) {
        return;
      }

      device_category = device.category

      const lat = parseFloat(device.latitude)
      const lng = parseFloat(device.longitude)
      const icon = getIcon(device.course, device.status, device.category)
      const deviceMarker = L.marker([lat, lng], {icon: icon})
          // .bindPopup(myPopup(deviceInfo), {closeButton: false,})

      deviceMarkerLayers.addLayer(deviceMarker)
      deviceMarkerLayers.addTo(map.value)
      deviceMarker.setZIndexOffset(99)
      devices.value[device.id] = deviceMarker
      deviceMarker.on('click', function(e) {})
      devices.value[device.id] = deviceMarker
    }

    const initNewPopup = p => {
      const pop = new info({
        propsData: {
          point: {
            speed: p.speed,
            time: p.devicetime,
            status: p.status
          }
        }
      })

      pop.$mount()
      return pop.$el
    }

    const initNewContainerPopup = c => {
      const pop = new containerInfo({
        propsData: {
          container: {
            tag: c.tag,
            code: c.code,
            lastupdate: c.lastupdate,
            device: null
          }
        }
      })

      pop.$mount()
      return pop.$el
    }

    const getIcon = (angle, status = 'moving', cat = 'default') => {
      let img;
      try {
        img = require(`@/assets/markers/${cat}/${status}.svg`)
      } catch (e) {
        img = require(`@/assets/markers/${status}.svg`)
      }

      return L.divIcon({
        html: L.Util.template(`<div class="rotate-${angle}"><img src="${img}" alt=""></div>`),
        iconSize    : [30, 40], })
    }

    const getIconWithImg = img => {
      return L.divIcon({
        html: L.Util.template(`<div style="width: 30px"><img style="width: 30px" src="${img}" alt=""></div>`),
        iconSize    : [30, 40], })
    }

    const _move = data => {

      const icon = getIcon(data.device_angle, data.device_status, device_category)

      const marker = devices.value[data.device_id]

      marker.setLatLng([data.device_latitude, data.device_longitude]);
      marker.setIcon(icon)
      marker.bindPopup(myPopup(data), {closeButton: false,})

      deviceInfo.value.speed = data.device_speed
      deviceInfo.value.devicetime = data.device_devicetime
      deviceInfo.value.status = data.device_status

      if (devicePath.value) {
        devicePath.value.addLatLng([
            data.device_latitude,
          data.device_longitude
        ])
      }

      if (panTo.value) {
        map.value.panTo(marker.getLatLng())
      }

    }

    const move = (message, time)  => {

      const icon = getIcon(message.course, message.status, device_category)
      const marker = devices.value[message.id]

      const moveto = {lat: message.latitude, lng: message.longitude}
      const current = marker.getLatLng();


      let deltalat = (moveto.lat - current.lat) / 100;
      let deltalng = (moveto.lng - current.lng) / 100;

      let delay = 10 * time;
      for (let i = 0; i < 100; i++) {
        (function(ind) {
          setTimeout(
              function() {
                let lat = marker.getLatLng().lat;
                let lng = marker.getLatLng().lng;
                lat += deltalat;
                lng += deltalng;

                marker.setLatLng([lat, lng]);
              }, delay * ind
          );
        })(i)
      }

      (function (msg,  icon, moveto, marker) {
        setTimeout(function() {

              deviceInfo.value.speed = msg.speed
              deviceInfo.value.devicetime = msg.devicetime
              deviceInfo.value.status = msg.status
              deviceInfo.value.timeago = timeToString(msg.devicetime)

              if (devicePath.value) {
                devicePath.value.addLatLng([moveto.lat, moveto.lng])
              }
            }, 5500 // 5.5s
        );

      })(message, icon, moveto, marker)


      marker.setIcon(icon)
      marker.bindPopup(myPopup(message), {closeButton: false,})

      if (panTo.value) {
        map.value.panTo(marker.getLatLng())
      }
    }

    const incrementPointCount = message => {
      switch (message.status) {
        case "stop":
          stopsCount.value++
          break
        default:
          break
      }
    }

    const consumeQ = () => {

      setTimeout(function() {
        if (!movingQueue.isEmpty()) {
          const message = movingQueue.dequeue()
          incrementPointCount(message)
          move(message, 4,)
        }

        if (movingQueue.isRunning()) {
          consumeQ()
        }

        }, 6000
      );

    }

    const getVariant = type => {
      switch (type) {
        case 'lift':
          return ['warning', 'رفع حاوية']
        case 'geofenceEnter':
          return ['info', 'دخول منطقة']
        case 'deviceMoving':
          return ['info', 'تحرك المعدة']
        case 'deviceStopped':
          return ['danger', 'توقف المعدة']
        case 'geofenceExit':
          return ['danger', 'خروج من منطقة']
        default:
          return ['purple', 'رفع خارج الخطة']
      }
    }

    const getToastTitle = type => {
      switch (type) {
        case 'geofenceEnter':
          return  'دخول منطقة'
        case 'geofenceExit':
          return  'خروج من منطقة'
        case 'deviceMoving':
          return  'المعدة تحركت'
        case 'deviceStopped':
          return 'المعدة توقفت'
        case 'lift':
          return 'رفع حاوية'
        default:
          return 'غير معروف'
      }
    }

    const drawRoute = (linestring) => {

      const options = {  weight: 5, fillOpacity: 0.3, opacity: 0.5, color: '#6D214F'}
      const coordinatesString = linestring.replace('LINESTRING (', '').replace(')', '');
      const coordinatePairs = coordinatesString.split(', ');
      const points = coordinatePairs.map(pair => pair.split(' ').map(Number))
      routeLine.value = L.polyline(points, options).addTo(map.value)
    }

    const drawArea = area => {

      const options = {  weight: 5, fillOpacity: 0.3, opacity: 0.5, color: 'blue'}
      const points = area.area.split('((')[1].slice(0, -2).split(', ')
      const P = L.polygon(points.map((v, i) => [
        parseFloat(v.split(' ')[0]), parseFloat(v.split(' ')[1])]),options)
          .bindTooltip(`<div class="g_name" style="background: white;
                                font-size:1rem;padding:5px;
                                border:1px solid; !important; ">${area.name}</div>`, {
            permanent: false, direction:"center", className: 'bindTooltipStyle'}).openTooltip()
      areaLayers.addLayer(P)
    }

    const createMarkerPoint = (point, icon) => {
      return L.marker(
          point,
          { icon: icon }
      )
    }

    const initMap = () => {

      if (mapContainer.value) {
        let map_center = store.state.auth.userData?.map?.center ?? [24.7136, 46.6753]
        map.value = L.map(mapContainer.value).setView(map_center, 13);

        const googleStreets = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',{
          maxZoom: 20,
          subdomains:['mt0','mt1','mt2','mt3']
        }).addTo(map.value);

        const googleHybrid = L.tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',{
          maxZoom: 20,
          subdomains:['mt0','mt1','mt2','mt3']
        })

        // L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        // }).addTo(map.value);

        map.value.on('click', onMapClick);

        areaLayers.addTo(map.value)

        L.control.layers({googleStreets, googleHybrid }, {},{
          position: 'topleft'}).addTo(map.value)

      }
    };

    const onMapClick = (event) => {
      const { lat, lng } = event.latlng;

      // move(devices.value, 8, { lat, lng })

      // console.log(lat, lng)
      // containers.value.push([lat, lng])
      //
      // console.log(containers.value)

      // draw direction between these points

    };

    const getSocketInstance = async () => {
      if (webSocketManager.socket && webSocketManager.socket.readyState === WebSocket.OPEN) {
        return webSocketManager
      }
      await new Promise(resolve => setTimeout(resolve, 1000))
      return getSocketInstance()
    }

    const onSubmit = () => {

    }

    const handleBeforeUnload = (event) => {
      // perform before the page closed
      // sendMSG('stopDeviceTrace')
    };

    const sendMSG = async type => {
      let instance = await getSocketInstance()
      instance.send(JSON.stringify({
        "message_type": type,
        "deviceId": compactorId
      }));
    }

    const makePulseMarkerForSeconds = latLng => {
      const m = L.marker([latLng.latitude, latLng.longitude], { icon:
            L.divIcon({ className: 'pulse', iconSize: [15, 15] }) }).addTo(map.value);
      (function(ms) {
        setTimeout(function() {
              map.value.removeLayer(m)
            }, ms
        );
      })(10000)
    }

    const fitOnEvent = event => {
      selectedEventId.value = event.id
      if (!selectedEventMarker.value) {
        selectedEventMarker.value =
            L.marker([event.latitude, event.longitude], {
              icon: L.divIcon({ className: 'pulse', iconSize: [15, 15] }) })
                .addTo(map.value);

        (function(ms) {
          setTimeout(function() {
                map.value.removeLayer(selectedEventMarker.value)
                selectedEventMarker.value = null
                selectedEventId.value = 0
              }, ms
          );
        })(5000)
      }
      else {
        selectedEventMarker.value.setLatLng([
            event.latitude,
          event.longitude
        ])
      }

    }

    const hideSideBar = () => {
      eventsSideBarStatus.value = false
      settingsSideBarStatus.value = false
      containersSideBarStatus.value = false
    }

    getCompactorPlan()

    onUnmounted(() => {
      movingQueue.stop()
      clearTimeout(timeoutId)
    })

    onMounted( () => {

      window.addEventListener('beforeunload', handleBeforeUnload);
      document.getElementsByTagName('html')[0].dir = 'ltr'
      initMap();

      const CustomControl = L.Control.extend({
        onAdd: function(map) {

          const container = L.DomUtil.create('div', 'custom-control')
          const settingsButton = L.DomUtil.create('button', 'custom-button', container)
          settingsButton.innerHTML = 'اعدادات';

          const eventsButton = L.DomUtil.create('button', 'custom-button', container)
          eventsButton.innerHTML = 'الاحداث';

          const containersButton = L.DomUtil.create('button', 'custom-button', container)
          containersButton.innerHTML = 'الحاويات';

          settingsButton.addEventListener('click', function() {
            settingsSideBarStatus.value = !settingsSideBarStatus.value;
            eventsSideBarStatus.value = false
            containersSideBarStatus.value = false
          })


          eventsButton.addEventListener('click', function() {
            eventsSideBarStatus.value = !eventsSideBarStatus.value
            settingsSideBarStatus.value = false
            containersSideBarStatus.value = false
          });

          containersButton.addEventListener('click', function() {
            containersSideBarStatus.value = !containersSideBarStatus.value
            settingsSideBarStatus.value = false
            eventsSideBarStatus.value = false
          });

          return container;
        }
      })
      const customControl = new CustomControl()
      customControl.addTo(map.value);

      // sendMSG('startDeviceTrace')
      /*

      consumeQ() for animate marker

      eventBus.$on('deviceUpdateLocation', message => {
        console.log(message)
        if (message.id in devices.value) {
          // movingQueue.enqueue(message) // for animate marker
          _move(message)
        }
      })



      eventBus.$on('container-lift', message => {
        console.log(message)
        compactorLiftedContainersCount.value++
        const type = message.tag in containersCircles.value
            ? 'lift'
            : "unknown"

        initContainerCircleFromMessage({...message, inPlan: type !== "unknown"})
        pushNewEvent(message, getVariant(type))
        updateContainerList(message)
      })

       */

    });

    watch(route, (route) => {
      drawRoute(route.area)
    })

    watch(showMovePoints, (showMovePoints) => {
      showMovePoints
          ? devicePathMovingPointsLayers.addTo(map.value)
          : devicePathMovingPointsLayers.remove()
    })

    watch(showStopPoints , (showStopPoints) => {
      showStopPoints
          ? devicePathStopsPointsLayers.addTo(map.value)
          : devicePathStopsPointsLayers.remove()
    })

    watch(showGeofences , (showGeofences) => {
      showGeofences
          ? areaLayers.addTo(map.value)
          : areaLayers.remove()
    })

    const myPopup = data =>  `<div class="custom-popup">
                <div class="header">${data.device_name}</div>
                <table class="custom-popup-table">
                   <tr>
                     <td>speed</td>
                     <td class="float-endx">${data.device_speed}</td>
                   </tr>
                    <tr>
                     <td>status</td>
                     <td class="float-endx">${data.device_status}</td>
                   </tr>
                    <tr>
                     <td>lastupdate</td>
                     <td class="float-endx">${ data.device_devicetime }</td>
                   </tr>
                   <tr>
                     <td>lastupdate</td>
                     <td class="float-endx">${ moment(data.device_devicetime).fromNow() }</td>
                   </tr>

                </table>
              </div>`

    return {
      panTo,
      showGeofences,
      showContainers,
      showPoints,
      showMovePoints,
      showStopPoints,
      stopsCount,

      selectedEventId,
      eventsSideBarStatus,
      settingsSideBarStatus,
      containersSideBarStatus,
      requestStatus, error,
      deviceInfo,
      mapContainer,
      compactorPlannedContainersCount,
      compactorLiftedContainersCount,
      map,
      devices,
      events,containersList,
      onSubmit,
      fitOnEvent,
      hideSideBar,
    }

  }

};
</script>

<style lang="less">

.custom-button {
  all: unset;
  display: inline-block;
  cursor: pointer;

  background: #1b2337;
  margin: 2px;
  padding: 2px;
  border-radius: 1px;

}

.h-100 > div {
  height: 100%;
}

.b-sidebar-outer{
  height: 0 !important;
}

.leaflet-div-icon {
  background: none !important;
  border: none !important;
}

.pulse {
  background: rgb(163, 241, 9);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  position: absolute;
  margin-left: -10px;
  margin-top: -10px;
  animation: pulse 1s ease-out infinite;
}

.pulse_red {
  display: block;
  border-radius: 50%;
  cursor: pointer;
  animation: pulse 2s infinite;
  width: 10px;
  height: 10px;
  color: red;
  background: red;
}

.pulse_warning {
  display: block;
  border-radius: 50%;
  cursor: pointer;
  animation: pulse 10s infinite;
  width: 12px;
  height: 12px;
  color: #ff9f43;
  background: #ff9f43;
}

.marker_point {
  display: block;
  border-radius: 50%;
  cursor: pointer;
  width: 10px;
  height: 10px;
  background: #3a865a;
}

@keyframes pulse {
  0% {box-shadow: 0 0 0 0;}
  70% {box-shadow: 0 0 0 15px rgba(0, 0, 0, 0);}
  100% {box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);}
}

.generate-rotate-rules(359);
.generate-rotate-rules(@n, @i: 0) when (@i =< @n) {
  .rotate-@{i} {
  transform: rotate(unit(@i, deg)); /* CSS3 */
  -moz-transform: rotate(unit(@i, deg)); /* Firefox */
  -webkit-transform: rotate(unit(@i, deg)); /* Webkit */
  -o-transform: rotate(unit(@i, deg)); /* Opera */
  -ms-transform: rotate(unit(@i, deg)); /* IE 9 */
}
  .generate-rotate-rules(@n, (@i + 1));
}


</style>
